import React from 'react';
import { motion } from 'framer-motion';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { TrendingUpIcon, ArrowRightIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
export function TrendingProducts() {
  const {
    scrollContainerRef,
    isMobile,
    handleScroll
  } = useHorizontalScroll();
  const products = [{
    id: 1,
    name: 'Retinol Serum 2.5%',
    brand: 'The Ordinary',
    price: 34.99,
    originalPrice: 49.99,
    discount: 30,
    rating: 4.9,
    reviewCount: 2456,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Hyaluronic Acid Serum',
    brand: 'CeraVe',
    price: 29.99,
    originalPrice: 44.99,
    discount: 33,
    rating: 4.8,
    reviewCount: 1823,
    image: PRODUCT_IMAGES[1],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 3,
    name: 'Vitamin C Brightening Serum',
    brand: 'La Roche-Posay',
    price: 39.99,
    originalPrice: 59.99,
    discount: 33,
    rating: 4.7,
    reviewCount: 3102,
    image: PRODUCT_IMAGES[2],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 4,
    name: 'Niacinamide 10% + Zinc 1%',
    brand: 'The Ordinary',
    price: 24.99,
    originalPrice: 34.99,
    discount: 29,
    rating: 4.6,
    reviewCount: 1567,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Moisturizing Cream',
    brand: 'Neutrogena',
    price: 19.99,
    originalPrice: 29.99,
    discount: 33,
    rating: 4.5,
    reviewCount: 2234,
    image: PRODUCT_IMAGES[4],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'Sunscreen SPF 50+',
    brand: 'Bioderma',
    price: 32.99,
    originalPrice: 44.99,
    discount: 27,
    rating: 4.8,
    reviewCount: 1890,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }];
  return <div className="w-full" data-id="element-2555" data-mp="1fx2x848qrdss">
      <div className="container mx-auto px-4" data-id="element-2556" data-mp="1fwa07uzl42nu">
        <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl overflow-hidden mb-6" data-id="element-2557" data-mp="23l2n71y8b06b">
          <div className="p-6 md:p-8" data-id="element-2558" data-mp="28l74gu6ynyxl">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-2559" data-mp="28k5vcv9i9mii">
              <div className="mb-4 md:mb-0" data-id="element-2560" data-mp="1tv9lcsnw1zf9">
                <span className="text-xs font-bold text-white bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-2 inline-block uppercase" data-id="element-2561" data-mp="1yumajk28fil0">
                  WHAT'S HOT
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center" data-id="element-2562" data-mp="2rb6sreuz99zy">
                  <TrendingUpIcon className="w-6 h-6 md:w-8 md:h-8 mr-2" data-id="element-2563" data-mp="fw7u6amkaz6j" />
                  Trending Now
                </h2>
              </div>
              <a href="#" className="text-white bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center" data-id="element-2564" data-mp="awbqydlovbs1">
                View All
                <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-2565" data-mp="kpahw24nreet" />
              </a>
            </div>
          </div>
        </div>
        {/* Mobile Slider */}
        {isMobile ? <div className="relative -mx-4" data-id="element-2566" data-mp="3o5hk047fd3lh">
            <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3 px-4 pb-4" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-2567" data-mp="5xs66giu0619">
              {products.map((product, idx) => <motion.div key={product.id} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05,
            duration: 0.4
          }} className="snap-start flex-shrink-0 w-[42vw] max-w-[200px]" data-id="element-2568" data-mp="27pbyoug4kcik" data-mpi={idx}>
                  <EnhancedProductCard product={product} data-id="element-2569" data-mp="30dzg2exr6hqu" />
                </motion.div>)}
            </div>
          </div> :
      // Desktop Grid
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2570" data-mp="3abdxagri3ak7">
            {products.map((product, idx) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05,
          duration: 0.4
        }} data-id="element-2571" data-mp="3ediol8uh7v3o" data-mpi={idx}>
                <EnhancedProductCard product={product} data-id="element-2572" data-mp="1mdmlvzat2ds2" />
              </motion.div>)}
          </div>}
      </div>
    </div>;
}